module.exports = __webpack_public_path__ + "img/pin_easy_laverie.05308ba0.svg";